import { ReactElement, useMemo } from 'react'
import { GetStaticPathsContext, GetStaticPropsContext, InferGetStaticPropsType } from 'next'

import Meta from '@/components/base/meta'
import PageBuilder from '@/components/layout/builder'
import Layout from '@/components/layout/layout'
import { normalizeHeadData } from '@/utils/pageData'
import { getPromiseFromFetch } from '@/utils/request'
import { API, MOCK_DATA } from '@/constants'

import { WPPageData, WPRoutes } from '@/types'

export default function Page(pageProps: InferGetStaticPropsType<typeof getStaticProps>) {
  const output = useMemo(() => {
    return <PageBuilder pageProps={pageProps} />
  }, [pageProps])

  return output
}

Page.getLayout = function getLayout(page: ReactElement, pageProps: WPPageData) {
  return (
    <Layout pageProps={pageProps}>
      <Meta pageProps={normalizeHeadData(pageProps)} />
      {page}
    </Layout>
  )
}

export async function getStaticProps(
  // eslint-disable-next-line no-unused-vars
  { params, locale, defaultLocale }: GetStaticPropsContext<{ routes: string[] }>
) {
  if (locale === 'default') return { notFound: true }

  const { data: pageProps } = MOCK_DATA
    ? { data: require(`@/data/pages/${params?.routes.join('/')}.json`) }
    : await getPromiseFromFetch<WPPageData>({
        method: 'get',
        url: `/${locale === defaultLocale ? '' : `${locale}/`}${params?.routes.join('/')}/`
      })

  // if (res.status === 404) return { notFound: true }
  // const { data: pageProps } = res

  return {
    props: {
      ...pageProps
    }
  }
}

export async function getStaticPaths({}: GetStaticPathsContext) {
  const { data: routes } = MOCK_DATA
    ? { data: require('@/data/routes.json') as WPRoutes }
    : await getPromiseFromFetch<WPRoutes>({
        method: 'get',
        url: API.ROUTES
      })

  /* console.log(
    routes.map((route) => ({
      params: { routes: route.routes.filter((item) => item !== route.locale) },
      locale: route.locale // === defaultLocale ? '' : route.locale
    }))
  ) */

  return {
    paths: routes.map((route) => ({
      params: { routes: route.routes.filter((item) => item !== route.locale) },
      locale: route.locale // === defaultLocale ? '' : route.locale
    })),
    fallback: 'blocking' // false
  }
}
